import { render, staticRenderFns } from "./AttachmentFilesPreview.vue?vue&type=template&id=f5c8ac32&scoped=true&"
import script from "./AttachmentFilesPreview.vue?vue&type=script&lang=ts&"
export * from "./AttachmentFilesPreview.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentFilesPreview.vue?vue&type=style&index=0&id=f5c8ac32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c8ac32",
  null
  
)

export default component.exports